var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1.70715C10.2348 1.70715 9.98043 1.81251 9.79289 2.00005L8.15057 3.64237C8.14919 3.64372 8.14781 3.64508 8.14645 3.64645C8.14508 3.64781 8.14372 3.64919 8.14237 3.65057L2.29289 9.50005C2.20003 9.59291 2.12637 9.70315 2.07612 9.82447C2.02587 9.9458 2 10.0758 2 10.2072V13C2 13.2653 2.10536 13.5196 2.29289 13.7072C2.48043 13.8947 2.73478 14 3 14H6C6.13261 14 6.25979 13.9474 6.35355 13.8536L14 6.20715C14.1875 6.01962 14.2929 5.76526 14.2929 5.50005C14.2929 5.23483 14.1875 4.98048 14 4.79294L11.2071 2.00005L10.8728 2.33431L11.2071 2.00005C11.0196 1.81251 10.7652 1.70715 10.5 1.70715ZM8.50002 4.70713L3 10.2072L3 13H5.79289L11.2929 7.50002L8.50002 4.70713ZM12 6.79292L13.2929 5.50005L10.5 2.70715L9.20713 4.00002L12 6.79292Z",
    fill: "#103045",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilGrey);
export default __webpack_public_path__ + "static/media/pencil_grey.8dbdf5bac7714797101f61b124441ff7.svg";
export { ForwardRef as ReactComponent };